import { render, staticRenderFns } from "./DeclarativeSection.vue?vue&type=template&id=b98f34ce&scoped=true"
import script from "./DeclarativeSection.vue?vue&type=script&lang=js"
export * from "./DeclarativeSection.vue?vue&type=script&lang=js"
import style0 from "./DeclarativeSection.vue?vue&type=style&index=0&id=b98f34ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b98f34ce",
  null
  
)

export default component.exports